<ng-container *ngIf="(layerStore.activeLayer | async) as activeLayer">
  <div class="popup-container" [ngClass]="data.type === HOVER_POPUP ? 'hover-popup' : ''" *ngIf="(layerStore.activeLevel | async) as activeLevel" [attr.data-cy]="'mapPopup'">
    <button app-icon-button iconSize="12px" class="close-button" [attr.data-cy]="'close-popup-button'" (click)="handleClose()" *ngIf="data.type !== HOVER_POPUP">
      <app-icon svgIcon="cancel"></app-icon>
    </button>

    <button app-icon-button iconSize="14px" class="drag-button" [attr.data-cy]="'drag-button'">
      <app-icon svgIcon="drag"></app-icon>
    </button>

    <div class="list-wrapper">
    <ng-container [ngSwitch]="data.type">
      <app-layers-popup-list *ngSwitchCase="DEFAULT_POPUP"
                             [title]="popupService.popupTitle"
                             [properties]="$any(data).properties | sortProperties"
                             [isSeeMoreActive]="popupService.isSeeMoreActive"
                             [activeLayer]="activeLayer"
                             [activeLevel]="activeLevel"
      >
      </app-layers-popup-list>

      <app-layers-popup-list
      *ngSwitchCase="HOVER_POPUP"
      [title]="$any(data).properties.name ?? (layerStore.activeLevel.value === H3_RES5_LEVEL_LAYER ? 'Cell (5 mile)' : 'Cell (1 mile)')"
      [properties]="$any(data).properties | sortProperties"
      [activeLayer]="activeLayer"
      [activeLevel]="activeLevel"
      [isHoverPopup]="true"
      >
      </app-layers-popup-list>

      <app-schools-popup-list *ngSwitchCase="SCHOOLS_POPUP"
                              [properties]="$any(data).properties"
                              [isSeeMoreActive]="popupService.isSeeMoreActive"
      >
      </app-schools-popup-list>

      <app-ori-popup-list *ngSwitchCase="ORI_POPUP"
                          [properties]="$any(data).properties"
                          [isSeeMoreActive]="popupService.isSeeMoreActive"
      ></app-ori-popup-list>
    </ng-container>
    </div>
    <button class="toggle-data-count" (click)="toggleSeeMore()" *ngIf="data.type !== HOVER_POPUP">
      {{ popupService.isSeeMoreActive ? 'Hide' : 'See more' }}
    </button>

    <div class="popup-tools" *ngIf="data.type === DEFAULT_POPUP">
      <button
        app-icon-button
        iconSize="12px"
        *ngIf="!accessService.isUnauthorized && accessService.hasPaidPlan()"
        (click)="isFeatureFavorite() ? handleRemoveFromFavorites() : handleAddToFavorites()"
        [matTooltip]="'Mark cell as favorite'"
        class="round-button"
      >
        <app-favorite-icon
          [strokeColor]="isFeatureFavorite() ? '#CA0018' : '#02a4ff'"
          [fillColor]="isFeatureFavorite() ? '#CA0018' : '#fff'"
          width="14px"
          height="14px"
        >
        </app-favorite-icon>
      </button>

      <button
        class="round-button"
        app-icon-button
        iconSize="16px"
        *ngIf="accessService.getIsAdmin()"
        (click)="handleDownloadXlsx()"
        [matTooltip]="'Download data (xlsx)'">
        <app-icon svgIcon="download"></app-icon>
      </button>

      <button
        class="round-button"
        app-icon-button
        iconSize="16px"
        (click)="handleShare()"
        [matTooltip]="'Copy location to clipboard'">
        <app-icon svgIcon="share"></app-icon>
      </button>

      <button
        (click)="handleActionButton()"
        class='action-button'
        [matTooltip]="isBusinessCategory ? 'Is this a good location for your business?' : 'Talk to AI-powered Map'"
        app-icon-button
        iconSize="14px"
      >
        {{ isBusinessCategory ? 'Forecast Sales' : 'Chat with it' }}
        <app-icon [svgIcon]="isBusinessCategory ? 'site-selection' : 'gpt'"></app-icon>
      </button>
    </div>

    <div
      class="unlock-access-banner"
      *ngIf="data.type === DEFAULT_POPUP && accessService.isUnauthorized"
      [attr.data-cy]="'unlock-access-banner'"
    >
      <h4 class="unlock-access-title">Access the 5-mile resolution for neighborhood analysis</h4>
      <p class="unlock-access-subtitle">Free access, no card needed — just sign in to unlock it.</p>
      <button class="unlock-access-button" (click)="openSignUpModal()" [attr.data-cy]="'unlock-access-button'">
        Unlock access
      </button>
    </div>

    <div
      class="unlock-access-banner"
      *ngIf="data.type === DEFAULT_POPUP && !accessService.isUnauthorized && !accessService.hasPaidPlan() && !accessService.getIsAdmin() && activeLevel === H3_RES5_LEVEL_LAYER"
      [attr.data-cy]="'unlock-full-access-banner'"
    >
      <h4 class="unlock-access-title">Unlock all insights with 1-mile resolution for location intelligence</h4>
      <div class="unlock-access-chips">
        <span>1mi cells</span>
        <span>More reports</span>
        <span>More data</span>
      </div>
      <button class="unlock-access-button" (click)="openFullAccessModal()" [attr.data-cy]="'unlock-full-access-button'">
        Unlock full access
      </button>
    </div>
  </div>
</ng-container>
